module.exports = __webpack_public_path__ + "img/A58A0514_min.44803ae0.jpg";